<template>
  <div>
    <v-autocomplete
      :value="campus"
      :items="filterCampus"
      :label="$i18n.t(label)"
      @change="changedTo"
      @click:clear="clear"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      ref="select"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div ripple dense class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <div ripple dense style="width:100%">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import Themeable from "vuetify/lib/mixins/themeable";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "CampusSelect",
  props: {
    value: {
      default: false,
    },
    corp: {
      default: false,
    },
    label: {
      default: "Campus",
    },
    clearable: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class CampusSelect extends (Vue, Themeable) {
  campus = null;
  campuses = [];
  loading = true;
  filter = "";

  get filterCampus() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.campuses;
    const fs = this.campuses.filter(function(s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) this.campus = newVal;
    if (newVal && newVal._id) this.$emit("input", newVal._id);
    if (!newVal) this.$emit("input", null);
  }

  selectValue() {
    if (this.value) {
      for (let i = 0; i < this.campuses.length; i++) {
        if (this.campuses[i]._id === this.value) {
          this.campus = this.campuses[i];
          break;
        }
      }
    }
  }

  async init(val) {
    if (val != null && val !== "") {
      this.filter = "";
      this.loading = true;
      this.campuses = await doGet("/api/campus/" + val + "/campus/all");
      this.loading = false;
      this.selectValue();
    } else {
      this.campuses = [];
      this.loading = false;
      this.selectValue();
    }
  }

  async mounted() {
    await this.init(this.corp);
    this.selectValue();
    this.loading = false;
  }

  @Watch("corp", { immediate: true })
  async onCorpChange(val) {
    await this.init(val);
    this.clear();
  }

  clear() {
    this.filter = "";
    this.campus = null;
    this.$emit("input", null);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
</style>
